import type { PublicationItem } from 'components/discover/publications/model';
import { useCallback } from 'react';

import { usePlayVideoState } from '../../contexts/PlayVideoContext';
import { PublicationSharedProps } from '../publication';

export function useOpenPublication(item: PublicationItem, trackOpen: PublicationSharedProps['trackOpen']) {
  const { title, documentUrl, videoId } = item;
  const playState = usePlayVideoState();
  const onPlayClicked = useCallback(() => {
    if (playState?.isPlaying === false && videoId) {
      trackOpen();
      playState.play(videoId, title);
    }
  }, [playState, videoId, title, trackOpen]);

  return useCallback(() => {
    if (documentUrl !== undefined) {
      trackOpen();
      window.open(documentUrl);
    } else {
      onPlayClicked();
    }
  }, [documentUrl, onPlayClicked, trackOpen]);
}
